export const TAP_HINT_KEY = 'pubword_tap_hint_seen';
export const MAX_PICKS = 9;

/** Map a typed guess onto concrete tile indices (left-to-right for typing). */
export function assignIndicesForGuess(letters, guess) {
  const indices = [];
  const used = new Set();
  const pool = String(letters || '').toUpperCase();
  for (const ch of String(guess || '').toUpperCase()) {
    for (let i = 0; i < pool.length; i++) {
      if (!used.has(i) && pool[i] === ch) {
        used.add(i);
        indices.push(i);
        break;
      }
    }
  }
  return indices;
}

export function guessFromIndices(letters, indices) {
  const pool = String(letters || '').toUpperCase();
  return indices.map((i) => pool[i] || '').join('');
}

/**
 * Next picked indices after tapping a tile, or null if the tap is ignored.
 * Only the most recently picked tile can be untapped (LIFO).
 */
export function togglePick(pickedIndices, index, max = MAX_PICKS) {
  if (pickedIndices.includes(index)) {
    if (index !== pickedIndices[pickedIndices.length - 1]) return null;
    return pickedIndices.slice(0, -1);
  }
  if (pickedIndices.length >= max) return null;
  return [...pickedIndices, index];
}

function defaultStorage() {
  try {
    return typeof window !== 'undefined' ? window.localStorage : undefined;
  } catch {
    return undefined;
  }
}

export function readTapHintSeen(storage = defaultStorage()) {
  try {
    return storage?.getItem(TAP_HINT_KEY) === '1';
  } catch {
    return false;
  }
}

export function markTapHintSeen(storage = defaultStorage()) {
  try {
    storage?.setItem(TAP_HINT_KEY, '1');
  } catch {
    // Private mode: hint just reappears next visit.
  }
}

/** True for mouse/trackpad devices; on phones focusing the input pops the keyboard over the tiles. */
export function hasFinePointer(win = typeof window !== 'undefined' ? window : undefined) {
  return Boolean(win?.matchMedia?.('(pointer: fine)').matches);
}
